<template>
  <div>

    <event-order-list :check="true" @order-selected="handleOrder"></event-order-list>

    <div class="container-center">
      <el-button type="primary" @click="save">保存</el-button>
    </div>

  </div>
</template>

<script>
import {saleorder} from "@/api/saleorder";
import {msg} from "@/assets/js/my-vue-element-ui-js";
import {mapActions} from "vuex";
import EventOrderList from "@/components/eventorder/EventOrderList.vue";

export default {
  name: 'SaleOrderEventCreate',
  components: {EventOrderList},

  props: {
    saleOrderId: Number
  },

  data() {
    return {
      list: [],
      eventOrderId: null,
    };
  },

  methods: {
    ...mapActions('saleOrder', ['triggerRefreshSalrOrderList']),

    handleOrder(orderId) {
      this.eventOrderId = orderId;
    },

    save() {
      saleorder.saveEventOrder(this.saleOrderId, this.eventOrderId).then(res => {
        msg(res, this);
        if (res.code === 200) {
          this.eventOrderId = null;
          this.$emit("created");
          this.triggerRefreshSalrOrderList();
        }
      })

    },
  },


};
</script>

<style scoped>
.container-center {
  margin-top: 15px;
}
</style>
